import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import JSONTree from 'react-json-tree';

const DebugContainer = ({ enabled, data, theme }) => {
    if (!enabled) {
        return null;
    }

    const jsonData = {
        ...data,
        spid: {
            ...data.spid,
            identity: undefined,
        },
    };

    return (
        <div className={ theme.debug }>
            <h3 className={ theme.header }>Debug data</h3>
            <JSONTree data={ jsonData } invertTheme={ false } />
        </div>
    );
};

DebugContainer.propTypes = {
    enabled: PropTypes.bool.isRequired,
    data: PropTypes.shape({
        spid: PropTypes.shape({}),
    }).isRequired,
    theme: PropTypes.shape({}),
};

DebugContainer.defaultProps = {
    theme: {},
};

const mapStateToProps = state => ({
    enabled: state.debug,
    data: state,
});

export default connect(mapStateToProps)(DebugContainer);
